export const DATE_FORMAT = 'DD.MM.YYYY';

export const LIMIT_OPTIONS = [5, 10, 15];

export enum OrderMethodEnum {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export enum CertificatesPageTabsEnum {
  MY_CERTIFICATES = 'myCertificates',
  FAVOURITE_CERTIFICATES = 'favouriteCertificates',
  BROWSE_CERTIFICATES = 'browseCertificates',
}

export enum ChemistryPageTabsEnum {
  TEST_RESULTS = 'chemistryTestResults',
}

export enum BatteryCellsPageTabsEnum {
  TEST_RESULTS = 'batteryCellsTestResults',
  SHIPPING_CONFIRMATION = 'batteryCellsShippingConfirmation',
  RECEIVING_CONFIRMATION = 'batteryCellsReceivingConfirmation',
}

export enum BatteryPacksPageTabsEnum {
  TEST_RESULTS = 'batteryPacksTestResults',
  SHIPPING_CONFIRMATION = 'batteryCellsShippingConfirmation',
  RECEIVING_CONFIRMATION = 'batteryCellsReceivingConfirmation',
  CAR_DEALERS_SHIPPING_CONFIRMATION = 'carDealersShippingConfirmation',
}

export enum AuthoritiesPageTabsEnum {
  CHEMISTRY = 'chemistry',
  BATTERY_CELLS = 'batteryCells',
  BATTERY_PACKS = 'batteryPacks',
}
